import { render, staticRenderFns } from "./NotificationSaving.vue?vue&type=template&id=12370e2e&scoped=true"
import script from "./NotificationSaving.vue?vue&type=script&lang=js"
export * from "./NotificationSaving.vue?vue&type=script&lang=js"
import style0 from "./NotificationSaving.vue?vue&type=style&index=0&id=12370e2e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12370e2e",
  null
  
)

export default component.exports